import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import { useUserStore } from '@citiguide/frontend-core';

const AUTO_CENTER_ZOOM = 14;

/**
 * Must be mounted inside a <LeafletMapContainer>.
 * Flies the map to the user's GPS position the first time it becomes available.
 * Does not re-center if the user has already panned away.
 */
export default function MapAutoCenter() {
  const map = useMap();
  const { location } = useUserStore();
  const centeredRef = useRef(false);

  useEffect(() => {
    if (location && !centeredRef.current) {
      centeredRef.current = true;
      map.flyTo(location, AUTO_CENTER_ZOOM, { duration: 1.2 });
    }
  }, [location, map]);

  return null;
}
